import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34b63ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-grey" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Hier maak je"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("de verkiezingsposter"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("voor je eigen politieke partij.")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-blue" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Kies eerst een partij en een "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("slogan en maak daarna een foto.")
  ])
], -1))
const _hoisted_4 = { class: "container-dark-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_submit_button, {
        href: "/foto-maken",
        class: "start-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode("start")
        ]),
        _: 1
      })
    ])
  ]))
}